import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"]
  
  static values = {
    editing: {type: Boolean, default: false},
    id: {type: String}
  }

  static outlets = [ "audit--form-elements" ]

  connect () {
    this.setElementId();
    this.toggleEditing();
  }
  
  toggleEditing () {
    const element = this.element.closest('.audit-survey-step')
    if (this.editingValue === true) {
      element.classList.add('editing');
      if (!this.auditFormElementsOutlet.openElementsValue.includes(this.idValue)) {
        this.auditFormElementsOutlet.openElementsValue = this.auditFormElementsOutlet.openElementsValue.concat(this.idValue)
      }
    } else {
      element.classList.remove('editing');
    }
  }

  handleSubmitEnd(event) {
    if (this.formTarget.contains(event.target)) {
      if (event.detail.success) {
        // Update submission status to success
        this.auditFormElementsOutlet.submissionStatusesValue[this.idValue] = 'success';
        if (this.auditFormElementsOutlet.openElementsValue.includes(this.idValue)) {
          this.removeIdFromArray(this.idValue)
        }
      } else {
        // Update submission status to error
        this.auditFormElementsOutlet.submissionStatusesValue[this.idValue] = 'error';
      }
      this.auditFormElementsOutlet.populateErrorBox();
    }
  }

  handleCancel() {
    this.removeIdFromArray(this.idValue);
    this.removeIdFromSubmissionValues(this.idValue);
    this.auditFormElementsOutlet.populateErrorBox();
  }

  removeIdFromArray(id) {
    this.auditFormElementsOutlet.removeIdFromArray(id)
  }

  removeIdFromSubmissionValues(id) {
    this.auditFormElementsOutlet.removeIdFromSubmissionValues(id)
  }

  setElementId() {
    const frame = this.element.closest('.audit-survey-step').parentElement
    this.idValue = frame.id
  }
}
